// PAPERLIKE CUSTOM — Paperlike-built, no vanilla equivalent

if (!window.customElements.get('blog-tag-carousel')) {
  class BlogTagCarousel extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-tab-id]');
      this.panels = this.querySelectorAll('[data-tab-panel]');
      this.buttonGroups = this.querySelectorAll('[data-tab-buttons]');

      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.activateTab(tab.dataset.tabId);
        });
      });
    }

    activateTab(id) {
      this.tabs.forEach(tab => {
        const active = tab.dataset.tabId === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active);
      });

      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.tabPanel !== id;
      });

      this.buttonGroups.forEach(group => {
        group.hidden = group.dataset.tabButtons !== id;
      });
    }
  }

  customElements.define('blog-tag-carousel', BlogTagCarousel);
}
